import React from 'react';

import Thumb from '../img/blogs/some-javascript-interview-questions.jpg';

const SomeJavaScriptInterviewQuestions = {
    id: 17, permalink: "some-javascript-interview-questions", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 12, 2020", categories: "JavaScript", title: "Some JavaScript Interview Questions", shortDesc: "When you want a Web Developer job, In the Interview you will be faced with JavaScript related questions. So, here are some most Interview Questions about JavaScript.", fullDesc: <>
        <p>When you want a <strong>Web Developer</strong> job, In the <strong>Interview</strong> you will be faced with <strong>JavaScript</strong> related questions. So, here are some most <strong>Interview Questions</strong> about <strong>JavaScript</strong>, that can help you in the <strong>Interview</strong>.</p>


        <h2>Is there any difference between window and document?</h2>
        <p>Yes. The <strong>window</strong> is the <strong>global object of JavaScript</strong> and everything runs under it. It holds <strong>global variables, global functions, location, history</strong>, etc.</p>
        <p>The <strong>document</strong> (also known as <code>window.document</code>) is a property of the <strong>window object</strong>. But we can use <code>getElementById</code> or <code>addEventListener</code> on <strong>document</strong>. These methods are not present in the <strong>window object</strong>.</p>

        <pre className="code">
            <h4>In a Browser console</h4>
            window.document === document; <br />
            window.getElementById; <br />
            document.getElementById; <br />
        </pre>
        <p><strong>Expected output:</strong> <code className="output">true</code>, <code className="output">undefined</code> and <code className="output">function getElementById() &#123; [native code] &#125;</code></p>


        <h2>What is a repaint and when does repaint happen?</h2>
        <p><strong>repaint</strong> happens when we change the look of an element without changing its shape and size. Since the geometry of the element does not change, it does not cause <strong>reflow</strong>.</p>

        <h4>How it happens:</h4>
        <ul>
            <li>Change background-color</li>
            <li>Change text color</li>
            <li>Visibility hidden</li>
        </ul>


        <h2>How can you get all the texts on a web page?</h2>
        <p>To get all the texts from a <strong>web page</strong>, I will use the <code>innerText</code> of the <strong>body</strong> tag.</p>

        <pre className="code">
            <h4>In a Browser console</h4>
            document.body.innerText;
        </pre>


        <h2>What are the differences between null and undefined?</h2>
        <h4>undefined</h4>
        <p><strong>undefined</strong> means, the value of the <strong>variable</strong> is not defined. <strong>JavaScript</strong> has a global variable <code>undefined</code> whose value is "<code>undefined</code>" and typeof <code>undefined</code> is also "<code>undefined</code>".</p>

        <h4>null</h4>
        <p><strong>null</strong> means empty or <strong>non-existent</strong> value ​​that <strong>programmers</strong> use to indicate <strong>"no value"</strong>. <code>null</code> is a <strong>primitive</strong> value and we can assign <code>null</code> to any <strong>variable</strong>. <code>null</code> is not an <strong>object</strong>, it is a <strong>primitive</strong> value.</p>


        <h2>What are the differences between <code>==</code> and <code>===</code>?</h2>
        <p><code>==</code> compare just <strong>value</strong>, it doesn't compare <strong>type</strong>. If both sides are the same <strong>value</strong> <code>==</code> will return <code>true</code>.</p>
        <p><code>===</code> compare <strong>value</strong> and <strong>type</strong>. if both sides are the same <strong>value</strong> and same <strong>type</strong>, <code>===</code> will return <code>true</code>.</p>

        <pre className="code">
            console.log(10 == "10"); <br />
            console.log(10 === "10");
        </pre>
        <p><strong>Expected output:</strong> <code className="output">true</code> and <code className="output">false</code></p>


        <h2>Write a simple function to tell whether 5 is passed as a parameter or not?</h2>
        <p>Firstly, I will convert <code>arguments</code> to an array by calling the <code>slice</code> method on an array and pass <code>arguments</code>. After that, I will use <code>indexOf()</code>.</p>

        <pre className="code">
            function isFivePassed() &#123; <br />
                &nbsp; let args = Array.prototype.slice.call(arguments); <br />
                &nbsp; return args.indexOf(5) != -1; <br />
            &#125; <br />
            console.log(isFivePassed(1, 4)); <br />
            console.log(isFivePassed(5, 3, 1, 2));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">false</code> and <code className="output">true</code></p>


        <h2>What is the value of <code>3+2+4+"5"</code>?</h2>
        <p><code>95</code>. The addition starts from the left, <code>3+2</code> results <code>5</code>, and <code>5+4</code> is <code>9</code>. So far, the <code>plus</code> operator is performing addition as both the operands are number. After that <code>9 + "5"</code> where one of the operands is string and plus operator will perform concatenation.</p>


        <h2>What is the value of <code>"3"+2+6</code>?</h2>
        <p><code>"326"</code>. For this one <code>"3" + 2</code> will produce <code>"32"</code> and <code>"32"+6</code> will generates "326".</p>


        <h2>What is the value of <code>!'bang'</code> and <code>!'bang'</code>?</h2>
        <p>The first answer is <code>false</code> and the second is <code>true</code>.</p>

        <p><code>!</code> is <strong>NOT</strong>. If we put <code>!</code> in front of <strong>truthy</strong> values, it will return <code>false</code>.</p>

        <p>Using <code>!!</code> is a tricky way to check anything <strong>truthy</strong> or <strong>falsy</strong> by avoiding implicit type conversion of <code>==</code> comparison.</p>


        <h2>How could you set a prefix before everything you log?</h2>
        <p>I will take the <strong>function arguments</strong>, and convert it to an <strong>array</strong>, and <code>unshift</code> whatever prefix I want to set. Finally, I will use apply it to pass all the <strong>arguments</strong> to the <code>console</code>.</p>

        <pre className="code">
            function log() &#123; <br />
                &nbsp; let args = Array.prototype.slice.call(arguments); <br />
                &nbsp; args.unshift('(Wasek)'); <br />
                &nbsp; console.log.apply(console, args); <br />
            &#125; <br />
            log('Hello World!');
        </pre>
        <p><strong>Expected output:</strong> <code className="output">(Wasek) Hello World!</code></p>
    </>
};
export default SomeJavaScriptInterviewQuestions;